import { ChangeDetectionStrategy, Component, isDevMode } from '@angular/core';
import { DomainPageComponent, MainMenuService, MenuNode } from '@technocom/core';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';

type ExtendedMenuNode = MenuNode & { localeText: string; className: string };

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent extends DomainPageComponent {
  constructor(route: ActivatedRoute, protected menu: MainMenuService) {
    super(route);
  }

  get isDevMode(): boolean {
    return isDevMode();
  }

  rows: ExtendedMenuNode[][];

  protected onInit(): void {
    super.onInit();
    // убираем из dashboard кнопку "Главное", т.к. она перенаправляет на саму себя.
    const menuItems = this.menu.getMenu().find(item => item.id === 'master').children;
    // вряд ли мы будем менять менюшку в рантайме, поэтому можно собрать 1 раз
    this.rows = _.chunk(menuItems, 2) as ExtendedMenuNode[][];
  }
  protected onDestroy(): void {
    super.onDestroy();

    delete this.rows;
  }
}
